import styled from 'styled-components';


export const SuccessMsgWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding: ${props.theme.spacing.large.l30} ${props.theme.spacing.nospacing};
        line-height: ${props.theme.font.lineHeight.large};
        align-items: center;
        justify-content: center;
        text-align:${props.theme.font.textAlign.center};
        flex-direction: column;
        height: 60rem;
    `,
)

export const SuccessMsgText =  styled.p(
    props => `
    font-size: ${props.theme.font.large.font24};
    color: green ${props.theme.colors.green.base};
    line-height: ${props.theme.font.lineHeight.large}; 
    font-weight: ${props.theme.font.fontWeight.semiBold};
    padding-bottom: ${props.theme.spacing.base};
`);

export const CheckCircleWrap = styled.div(
    props => `
    width: 60px;
    height:60px;
    border-radius: ${props.theme.misc.borderRadius.round};
    align-items: center;
    justify-content: center;
    display: flex;
    background-color: green;
    margin-bottom: ${props.theme.spacing.large.l20};
`);

export const InfoText = styled.p(
    props =>`
    font-size: ${props.theme.font.large.font16};
    color: ${props.theme.colors.grey.dark3};
    line-height: ${props.theme.font.lineHeight.base};
    padding-top: ${props.theme.spacing.small.s5};
`);


export const ErrorMsgWrap = styled.div(
    props =>`
    width:100%;
    display: flex;
    padding: ${props.theme.spacing.large.l30} ${props.theme.spacing.nospacing};
    line-height: ${props.theme.font.lineHeight.large};
    align-items: center;
    justify-content: center;
    text-align:center;
    flex-direction: column;
    height: 60rem;
`);

export const ErrorMsgText =  styled.p(
    props => `
    font-size: ${props.theme.font.large.font24};
    color: ${props.theme.colors.red.base};
    line-height: ${props.theme.font.lineHeight.large};
    font-weight: ${props.theme.font.fontWeight.semiBold};
    padding-bottom: ${props.theme.spacing.base};
`);

export const ErrorCircleWrap = styled.div(
    props =>`
    width: 60px;
    height:60px;
    border-radius: ${props.theme.misc.borderRadius.round};
    align-items: center;
    justify-content: center;
    display: flex;
    background-color: ${props.theme.colors.red.base};
    margin-bottom: ${props.theme.spacing.large.l20};
`);

export const Exclamation = styled.p(
    props => `
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    font-size: ${props.theme.font.large.font30};
`);
